exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-item[data-v-71f7eff4] {\n  height: 270px;\n  margin-bottom: 20px;\n  border-radius: 10px;\n}\n.card-item[data-v-71f7eff4] .ant-statistic-title {\n  margin-bottom: 5px !important;\n}\n.card-item[data-v-71f7eff4] .ant-statistic-content {\n  font-weight: bold;\n  color: #333333;\n}\n.extra-wrapper[data-v-71f7eff4] {\n  line-height: 55px;\n  padding-right: 24px;\n  text-align: right;\n}\n.extra-wrapper .extra-item[data-v-71f7eff4] {\n  display: inline-block;\n  margin-right: 24px;\n}\n.extra-wrapper .extra-item a[data-v-71f7eff4] {\n  margin-left: 24px;\n}\n", ""]);

// exports
